import Button from "../../Shared/Button/Button";
import FilterHeader from "../../Shared/FilterHeader/FilterHeader";
import InputForm from "../Common/InputForm";

const ReportProblem = () => {
  return (
    <div className="col-span-3 mt-[60px]">
      <FilterHeader title={"Report A Problem"} dropdown={false} />
      <div>
        <div className="grid grid-cols-2 gap-x-14">
          <InputForm title={"Enter your Username here"} />
          <InputForm title={"User Name Being Reported Here"} />
        </div>
        <InputForm title={"Listing id here"} />
        <InputForm title={"Please Tell Us How can We Help"} rows="5" />
      </div>
      <div className="flex justify-end ">
        <Button
          text={"Submit"}
          variant="primary"
          className="mt-12 mb-[60px] !w-1/5 !text-2xl"
        />
      </div>
    </div>
  );
};

export default ReportProblem;
